//Container of the navigation items

import React from 'react';

import classes from './NavigationItems.module.css';
import NavigationItem from './NavigationItem/NavigationItem.js';
import Auxiliary from '../../../hoc/AuxComponent/AuxComponent';

import { css } from '@emotion/css';

const NavigationItems = props => {
    return (
        <Auxiliary>
            <div className={css`
                margin-bottom:60px;
            `}>

            </div>
            <div className={classes.Navbar}>
                <ul className={classes.NavigationItems}>
                    <NavigationItem link="/pokemonlist" >Pokemon List</NavigationItem>
                    <NavigationItem link="/mypokemon" >My Pokemon</NavigationItem>
                </ul>
            </div>
        </Auxiliary>
    );
};


export default NavigationItems;